import { render } from "./GallerySection.vue?vue&type=template&id=bb2821d6&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"

import "./GallerySection.vue?vue&type=style&index=0&id=bb2821d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2821d6"]])

export default __exports__